export class AppErrors {
    constructor(public originalError?: any){}
}
